import React from "react";
import "./SubFounder.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

const SubFounder = ({
  dotPattern,
  founderImage,
  heading,
  name,
  role,
  subname,
  subrole,
  messages,
  buttonText,
  contact,
  buttonLink
}) => {
  const navigate=useNavigate();
  return (
    <section className="subfounder-section">
      <div className="subfounder-container">
        <div className="subfounder-left">
          <div className="subfounder-image-wrapper">
            {dotPattern && <img src={dotPattern} alt="Dot pattern" className="subfounder-dot-pattern" />}
            <img src={founderImage} alt="Founder" className="subfounder-image" />
          </div>
        </div>
        <div className="subfounder-right">
          <h2 className="subfounder-heading">{heading}</h2>
          {(name || role) && (
  <h4 className="subfounder-name">
    {name && <span>{name}</span>}
    {role && <><br /><span>{role}</span></>}
  </h4>
)}

          {contact ? (
            <div className="subfounder-contact-block">
              <div className="subfounder-contact-row">
                <FaPhoneAlt className="subfounder-contact-icon" />
                <span>WhatsApp Helpline</span>
              </div>
              <div className="subfounder-contact-row">
                <FaEnvelope className="subfounder-contact-icon" />
                <a style={{textAlign:'left'}} href="mailto:care@vcnrworld.com" className="subfounder-contact-email">care@vcnrworld.com</a>
              </div>
              <div className="subfounder-contact-row" style={{ alignItems: 'flex-start' }}>
                <FaMapMarkerAlt className="subfounder-contact-icon" style={{ marginTop: 2 }} />
                <div>
                  <strong>VCNR Group</strong><br />
                  #135, VCNR Towers, Vinayaka nagar,<br />
                  BH Road, Binnamangala Nursery,<br />
                  Nelamangala Town, Karnataka 562123
                </div>
              </div>
              <div className="subfounder-contact-message">
                {messages.map((msg, idx) => (
  <li key={idx}>{msg}</li>
))}
                We welcome your questions, proposals, and ideas<br />let’s work together for a better tomorrow.
              </div>
            </div>
          ) : (
            messages.map((msg, idx) => (
              <p key={idx} className="subfounder-text">{msg}</p>
            ))
          )}
           {(subname || subrole) && (
          <h4 className="subfounder-name">
            {subname && subname} <br /> {subrole && subrole}
          </h4>
           )}
          {buttonText && <a href={buttonLink} target="_blank" rel="noopener noreferrer"><button className="subfounder-btn">{buttonText}</button></a>}
        </div>
      </div>
    </section>
  );
};

export default SubFounder;
